/* eslint-disable import/prefer-default-export */
import { defineStore } from "pinia";
export const useDistributionNavigationStore = defineStore("distributionNavigationStore", {
  state: () => ({
    showTimeFilterModal: false,
    showDistributionStatusModal: false,
    showUpdateDistributionModal: false,
    showAssignDestributionModal: false,
    paymentDefaultFilterChange: false,
    customInputOpen: false,
    type: '',
    updatedDistribution: {
      id: "",
      label: ""
    },
    section: {
      distributionId: null,
      selectedSectionToggle: 'Distribution'
    }
  }),
  actions: {
    sectionToggle(value) {
      this.section.selectedSectionToggle = value;
    },
    openDistributionDetail(page, distributionId) {
      this.section.selectedSectionToggle = page;
      this.section.distributionId = distributionId;
    },
    toggleUpdateDistributionModal(value, distribution, type) {
      this.showUpdateDistributionModal = value;
      this.type = type;
      if (!distribution) {
        this.updatedDistribution = {
          id: "",
          label: ""
        };
      } else {
        this.updatedDistribution = distribution;
      }
    },
    toggleTimeFilterModal(value) {
      this.showTimeFilterModal = value;
    },
    toggleDistributionStatusModal(value) {
      this.showDistributionStatusModal = value;
    },
    toggleAssignDestributionModal(value) {
      this.showAssignDestributionModal = value;
    },
    togglePaymentDefaultFilterChange(value) {
      this.paymentDefaultFilterChange = value;
    },
    toggleCustomInputOpenChange(value) {
      this.customInputOpen = value;
    }
  }
});